import script from "./KToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./KToggle.vue?vue&type=script&setup=true&lang=ts"

import "./KToggle.vue?vue&type=style&index=0&id=19a3194f&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a3194f"]])

export default __exports__